import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { NavBar } from '../components/NavBar';
import { usePublicaciones } from '../hooks/usePublicaciones';

export const Home = () => {
  const { getNotificaciones } = usePublicaciones();
  const lastUnreadIds = useRef(new Set());

  useEffect(() => {
    const checkNotifications = async () => {
      try {
        const data = await getNotificaciones();
        const unreadNotifications = data.filter(n => n.estado === 0);
        const currentUnreadIds = new Set(unreadNotifications.map(n => n.correlativo));

        const newIds = Array.from(currentUnreadIds).filter(id => !lastUnreadIds.current.has(id));

        if (newIds.length > 0) {
          const audio = new Audio('/sounds/notify.mp3');
          audio.play().catch(e => console.error("Error playing sound:", e));
        }
        
        lastUnreadIds.current = currentUnreadIds;
      } catch (error) {
        console.error("Failed to check notifications:", error);
      }
    };

    checkNotifications();
    const intervalId = setInterval(checkNotifications, 300000); // 5 minutes

    return () => clearInterval(intervalId);
  }, [getNotificaciones]);

  return (
    <>
      <NavBar />
      <Outlet />
    </>
  );
};